import { EventBus, MAP_IMG_URL, MAP_PDF_URL, MAP_SMS_URL } from "@/helpers";
import { getField, updateField } from "vuex-map-fields";
import { datetimeOptions, SURVEY_TYPE, USER_TYPE } from "@/const";
import { i18n } from "@/main";
import { surveyService } from "@/services";
import moment from "moment";
import formatcoords from "formatcoords";
import { store } from "@/store";

function mapSurveyEventsData(survey, eventIterator) {
  const mappedSurvey = {};
  mappedSurvey.id = survey._id.$oid;
  mappedSurvey.permission = survey.permission;
  mappedSurvey.projectname = survey.projectname;
  mappedSurvey.manufacturer = survey.manufacturer;
  mappedSurvey.rpas = survey.rpas;
  mappedSurvey.droneregistrationnumber = survey.droneregistrationnumber;
  mappedSurvey.serialno = survey.serialno;
  mappedSurvey.pilot = survey.pilotname;
  mappedSurvey.pilotname = survey.pilotname;
  mappedSurvey.pilotphone = survey.pilotphone;
  mappedSurvey.pilotemail = survey.pilotemail;
  mappedSurvey.pilotlicense = survey.pilotlicense;
  mappedSurvey.observername = survey.observername;
  mappedSurvey.payloadoperatorname = survey.payloadoperatorname;
  mappedSurvey.latitude = survey.latitude;
  mappedSurvey.longitude = survey.longitude;
  mappedSurvey.mission_reference_no = survey.mission_reference_no;
  mappedSurvey.flightReviewRubricUrl = survey.flightReviewRubricUrl;
  mappedSurvey.survey_type = survey.survey_type;
  mappedSurvey.title = survey.events[eventIterator].title;
  mappedSurvey.clientName = survey.customer_name;
  mappedSurvey.clientEmail = survey.customer_email;

  const siteCoordinates = formatcoords(
    survey.latitude,
    survey.longitude
  ).format("DDMMssX", {
    latLonSeparator: ", ",
    decimalPlaces: 0
  });
  mappedSurvey.address = survey.address;
  if (!mappedSurvey.address) {
    mappedSurvey.address = siteCoordinates;
  }

  mappedSurvey.controlled = survey.controlled;
  mappedSurvey.air_status = survey.air_status;
  mappedSurvey.start = new Date(survey.events[eventIterator].start.$date);
  mappedSurvey.startJson = mappedSurvey.start.toJSON();
  mappedSurvey.startTime = mappedSurvey.start.toLocaleString(
    window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US",
    datetimeOptions
  );
  mappedSurvey.startTimeLocal = mappedSurvey.start.toLocaleString(
    window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US"
  );
  mappedSurvey.end = new Date(survey.events[eventIterator].end.$date);
  mappedSurvey.endJson = mappedSurvey.end.toJSON();
  mappedSurvey.endTime = mappedSurvey.end.toLocaleString(
    window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US",
    datetimeOptions
  );
  mappedSurvey.endTimeLocal = mappedSurvey.end.toLocaleString(
    window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US"
  );

  mappedSurvey.img = survey.map_img ? MAP_IMG_URL + survey.map_img : "";
  mappedSurvey.pdf = survey.events[eventIterator].pdf
    ? MAP_PDF_URL + survey.events[eventIterator].pdf
    : "";
  mappedSurvey.pdf_file = survey.events[eventIterator].pdf
    ? survey.events[eventIterator].pdf
    : "";
  mappedSurvey.nav = survey.events[eventIterator].nav
    ? MAP_PDF_URL + survey.events[eventIterator].nav
    : "";
  mappedSurvey.mission_pdf = survey.events[eventIterator].mission_pdf
    ? MAP_SMS_URL + survey.events[eventIterator].mission_pdf
    : "";
  mappedSurvey.email = survey.email;
  mappedSurvey.operationradius = survey.operationradius;
  mappedSurvey.operationaltitude = survey.operationaltitude;
  mappedSurvey.radiusunit = survey.radiusunit;
  mappedSurvey.dronecolor = survey.dronecolor;
  mappedSurvey.fir = survey.fir;
  for (let y = 0; y < survey.nearestAerodromes.length; y++) {
    if (y === 0) {
      mappedSurvey.nearestAerodromes = survey.nearestAerodromes[y];
    } else {
      mappedSurvey.nearestAerodromes = `${mappedSurvey.nearestAerodromes}, ${survey.nearestAerodromes[y]}`;
    }
  }

  return mappedSurvey;
}

export function getDefaultPagination() {
  return {
    perPage: 10,
    currentPage: 1,
    perPageOptions: [10, 25, 50, 100],
    total: -1
  };
}

export function getDefaultSurveyDraft() {
  return {
    id: "",
    permission: false,
    projectname: "",
    pilotname: "",
    pilotfullname: "",
    pilotemail: "",
    pilotphone: "",
    dronemodel: "",
    manufacturer: "",
    rpas: "",
    droneregistrationnumber: "",
    dronecolor: "",
    serialno: "",
    pilotlicense: "",
    observername: "",
    payloadoperatorname: "",
    operationradius: "",
    radiusunit: "nm",
    operationaltitude: "",
    controlled: false,
    air_status: "",
    longitude: 0,
    latitude: 0,
    address: "",
    mapImageData: null,
    events: [],
    airport: null,
    flightSchool: "",
    reviewcustomer: "",
    surveyType: SURVEY_TYPE.UNSELECTED,
    clientName: "",
    clientEmail: ""
  };
}

function formatSurveyDateForRender(survey) {
  let surveyDraft = getDefaultSurveyDraft();
  Object.keys(surveyDraft).forEach(key => {
    if (survey.hasOwnProperty(key)) {
      surveyDraft[key] = survey[key];
    }
  });

  const rpas = surveyDraft.rpas;
  if (rpas.indexOf(" (") > -1) {
    //have nickname
    // dronemodel structure = `${drone.manufacturer}|${drone.model}|${drone.registrationnumber}|${drone.nickname}`;
    const model = rpas.split(" (")[0];
    const nickname = rpas.split(" (")[1].replace(")", "");
    surveyDraft.dronemodel = `${surveyDraft.manufacturer}|${model}|${surveyDraft.droneregistrationnumber}|${nickname}`;
  } else {
    // no nickname
    // dronemodel structure = `${drone.manufacturer}|${drone.model}|${drone.registrationnumber}`;
    surveyDraft.dronemodel = `${surveyDraft.manufacturer}|${surveyDraft.raps}|${surveyDraft.droneregistrationnumber}`;
  }

  // pilotfullname structure =  pilots.firstname + '|' + pilots.lastname + '|' + pilots.email + '|' + pilots.phone
  surveyDraft.pilotfullname =
    surveyDraft.pilotname.replace(" ", "|") +
    "|" +
    surveyDraft.pilotemail +
    "|" +
    surveyDraft.pilotphone;
  surveyDraft.reviewcustomer =
    surveyDraft.clientName && surveyDraft.clientEmail
      ? `${surveyDraft.clientName}|${surveyDraft.clientEmail}`
      : "";

  return surveyDraft;
}

export function getDroneInfo(
  drones,
  { manufacturer, model, registrationnumber }
) {
  let positionDrone = -1;
  const droneInfo = drones.find((item, idx) => {
    if (
      item.manufacturer === manufacturer &&
      item.model === model &&
      item.registrationnumber === registrationnumber
    ) {
      positionDrone = idx;
      return true;
    }
  });

  return {
    droneInfo: droneInfo || {},
    positionDrone
  };
}

export const survey = {
  namespaced: true,
  state: {
    newSurvey: true,
    isclone: false,
    surveyDraft: getDefaultSurveyDraft(),
    surveys: [], // can be newSurvey or oldSurvey
    pagination: getDefaultPagination(),
    airportDailySurveys: [],
    sms: [],
    surveyNotificationCount: 0,
    oldSurveyGeoData: {
      type: "FeatureCollection",
      name: "old_survey_geodata",
      features: []
    },
    newSurveyGeoData: {
      type: "FeatureCollection",
      name: "new_survey_geodata",
      features: []
    }
  },
  actions: {
    getSurveys(
      context,
      { type, currentPage, perPage, keywords, beginTime, endTime }
    ) {
      return surveyService
        .getSurveys({
          type,
          currentPage,
          perPage,
          keywords,
          beginTime,
          endTime
        })
        .then(response => {
          context.commit("setSurveys", {
            response,
            type
          });
        })
        .catch(error => {
          console.log("Error getSurveys: ", error);
          EventBus.$emit("failedGetSurveys", error);
        });
    },
    getAirportSurveys(
      context,
      { airportId, type, currentPage, perPage, keywords }
    ) {
      return surveyService
        .getAirportSurveys({ airportId, type, currentPage, perPage, keywords })
        .then(response => {
          context.commit("setSurveys", {
            response,
            type
          });
        })
        .catch(error => {
          console.log("Error getAirportSurveys: ", error);
          EventBus.$emit("failedGetAirportSurveys", error);
        });
    },
    getAirportDailySurveys(context, payload) {
      return surveyService
        .getAirportDailySurveys(
          payload.airportId,
          payload.startDate,
          payload.endDate
        )
        .then(response => {
          context.commit("setAirportDailySurveys", {
            response
          });
        })
        .catch(error => {
          console.log("Error setAirportDailySurveys: ", error);
          EventBus.$emit("failedGetAirportDailySurveys", error);
        });
    },
    getSurveyGeoData(context) {
      return surveyService
        .getSurveyGeoData()
        .then(response => {
          console.log(response);
          context.commit("setSurveyGeoData", {
            response
          });
        })
        .catch(error => {
          console.log("Error getSurveyGeoData: ", error);
          EventBus.$emit("failedGetSurveyGeoData", error);
        });
    },
    getSurveyDraft(context) {
      return surveyService
        .getSurveyDraft()
        .then(response => {
          console.log(response);
          context.commit("setSurveyDraft", {
            response
          });
        })
        .catch(error => {
          console.log("Error getSurveyDraft: ", error);
          EventBus.$emit("failedGetSurveyDraft", error);
        });
    },
    saveSurveyDraftStepOne(context) {
      return surveyService
        .saveSurveyDraftStepOne(
          context.state.newSurvey,
          context.state.surveyDraft
        )
        .then(response => {
          console.log(response);
          context.commit("saveSurveyDraftStepOne", {
            response
          });
          EventBus.$emit("savedSurveyDraftStepOne");
        })
        .catch(error => {
          console.log("Error saveSurveyDraftStepOne: ", error);
          EventBus.$emit("failedSaveSurveyDraftStepOne", error);
        });
    },
    saveSurveyDraftStepTwo(context, payload) {
      context.commit("saveSurveyDraftStepTwo", payload);
      return surveyService
        .saveSurveyDraftStepTwo(payload)
        .then(response => {
          console.log(response);
          context.dispatch("saveSurveyDraftMapImage", payload);
        })
        .catch(error => {
          console.log("Error saveSurveyDraftStepTwo: ", error);
          EventBus.$emit("failedSaveSurveyDraftStepTwo", error);
        });
    },
    saveSurveyDraftMapImage(context, payload) {
      context.commit("saveMapImageData", payload);
      return surveyService
        .saveSurveyDraftMapImage(context.state.surveyDraft.mapImageData)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log("Error saveSurveyDraftMapImage: ", error);
          EventBus.$emit("failedSaveSurveyDraftMapImage", error);
        });
    },
    saveSurveyDraftStepThree(context, payload) {
      context.commit("saveEvents", payload);
      return surveyService
        .saveSurveyDraftStepThree(context.state.surveyDraft.events)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log("Error saveSurveyDraftStepThree: ", error);
          EventBus.$emit("failedSaveSurveyDraftStepThree", error);
        });
    },
    submitSurveyDraft(context, payload) {
      return surveyService
        .submitSurveyDraft(payload)
        .then(response => {
          console.log(response);
          context.commit("submitSurveyDraft", {
            response
          });
        })
        .catch(error => {
          console.log("Error submitSurveyDraft: ", error);
          EventBus.$emit("failedSubmitSurveyDraft", error);
        });
    },
    getCoordinates(context, query) {
      return surveyService
        .getCoordinates(query)
        .then(response => {
          console.log(response);
          context.commit("setMapboxCoordinates", {
            response
          });
          EventBus.$emit("getCoordinates");
        })
        .catch(error => {
          console.log("Error getCoordinates: ", error);
          EventBus.$emit("failedGetCoordinates", error);
        });
    },
    getAirportIfApplicable(context) {
      return surveyService
        .getAirportIfApplicable()
        .then(response => {
          console.log(response);
          context.commit("setAirport", {
            response
          });
        })
        .catch(error => {
          console.log("Error getAirportIfApplicable: ", error);
          EventBus.$emit("failedGetAirportIfApplicable", error);
        });
    },
    getControlled(context, coords) {
      context.commit("setCoordinates", {
        coords
      });
      return surveyService
        .getControlled(
          context.state.surveyDraft.longitude,
          context.state.surveyDraft.latitude,
          this.state.auth.usertype === USER_TYPE.MAAC
        )
        .then(response => {
          console.log(response);
          context.commit("setControlled", {
            response
          });
        })
        .catch(error => {
          console.log("Error getControlled: ", error);
          EventBus.$emit("failedSetControlled", error);
        });
    },
    saveFlightLogs(context, flightlogs) {
      return surveyService
        .saveFlightLogs(flightlogs)
        .then(response => {
          console.log(response);
          context.commit("saveFlightLogs", {
            flightlogs
          });
        })
        .catch(error => {
          console.log("Error saveFlightLogs: ", error);
          EventBus.$emit("failedSaveFlightLogs", error);
        });
    },
    saveEvent(context, event) {
      return surveyService
        .saveEvent(event)
        .then(response => {
          console.log(response);
          context.dispatch("getSurveys");
        })
        .catch(error => {
          console.log("Error saveEvent: ", error);
          EventBus.$emit("failedSaveEvent", error);
        });
    },
    getSMS(context) {
      return surveyService
        .getSMS()
        .then(response => {
          console.log(response);
          context.commit("setSMS", {
            response
          });
        })
        .catch(error => {
          console.log("Error getSMS: ", error);
          EventBus.$emit("failedGetSMS", error);
        });
    },
    ackSMS(context, payload) {
      return surveyService
        .ackSMS(payload.id)
        .then(response => {
          console.log(response);
          context.commit("ackSMS", {
            response,
            id: payload.id
          });
        })
        .catch(error => {
          console.log("Error ackSMS: ", error);
          EventBus.$emit("failedAckSMS", error);
        });
    },
    deleteMission(context, payload) {
      return surveyService
        .deleteMission(payload)
        .then(response => {
          // onDeleteSuccess cbfn
          payload.onDeleteSuccess && payload.onDeleteSuccess(response);
        })
        .catch(error => {
          console.log("Error deleteMission: ", error);
          EventBus.$emit("failedDeleteMission", error);
        });
    },
    generateMissionReport(context, payload) {
      return surveyService
        .generateMissionReport(payload)
        .then(response => {
          // onGenerateMissionReportSuccess cbfn
          payload.onGenerateMissionReportSuccess &&
            payload.onGenerateMissionReportSuccess(response);
        })
        .catch(error => {
          console.log("Error generateMissionReport: ", error);
          EventBus.$emit("failedGenerateMissionReport", error);
        });
    },
    setLiveStreaming(context, payload) {
      return surveyService
        .setLiveStreaming(payload)
        .then(response => {
          console.log(response);
          context.commit("setLiveStreaming", {
            response: response,
            payload: payload
          });
        })
        .catch(error => {
          console.log("Error setLiveStreaming: ", error);
        });
    }
  },
  mutations: {
    updateSurveyField(state, field) {
      updateField(state, field);

      if (field.path === "surveyDraft.projectname") {
        state.surveyDraft.pilotname = "";
        state.surveyDraft.pilotfullname = "";
        state.surveyDraft.pilotlicense = "";
        state.surveyDraft.pilotemail = "";
        state.surveyDraft.pilotphone = "";
        state.surveyDraft.dronemodel = "";
        state.surveyDraft.manufacturer = "";
        state.surveyDraft.rpas = "";
        state.surveyDraft.droneregistrationnumber = "";
        state.surveyDraft.dronecolor = "";
        state.surveyDraft.serialno = "";
        state.surveyDraft.observername = "";
        state.surveyDraft.payloadoperatorname = "";
      }

      if (field.path === "surveyDraft.dronemodel" && field.value === "") {
        state.surveyDraft.manufacturer = "";
        state.surveyDraft.rpas = "";
        state.surveyDraft.droneregistrationnumber = "";
        state.surveyDraft.dronecolor = "";
        state.surveyDraft.serialno = "";
      } else if (
        field.path === "surveyDraft.dronemodel" &&
        field.value !== ""
      ) {
        const drone = field.value.split("|");
        state.surveyDraft.manufacturer = drone[0];
        state.surveyDraft.rpas = drone[3]
          ? `${drone[1]} (${drone[3]})`
          : drone[1];
        state.surveyDraft.droneregistrationnumber = drone[2];
        const { droneInfo } = getDroneInfo(this.state.setting.drones, {
          manufacturer: drone[0],
          model: drone[1],
          registrationnumber: drone[2]
        });
        state.surveyDraft.dronecolor = droneInfo.color;
        state.surveyDraft.serialno = droneInfo.serialno;
      } else if (
        field.path === "surveyDraft.pilotfullname" &&
        field.value !== ""
      ) {
        const pilotNames = field.value.split("|");
        state.surveyDraft.pilotemail = pilotNames[2];
        state.surveyDraft.pilotphone = pilotNames[3];
        state.surveyDraft.pilotname = pilotNames[0] + " " + pilotNames[1];
        state.surveyDraft.pilotlicense = this.state.setting.pilots.find(
          x => x.firstname === pilotNames[0] && x.lastname === pilotNames[1]
        ).license;
      } else if (
        field.path === "surveyDraft.reviewcustomer" &&
        field.value !== ""
      ) {
        const pilotNames = field.value.split("|");
        state.surveyDraft.clientName = pilotNames[0];
        state.surveyDraft.clientEmail = pilotNames[1];
        state.surveyDraft = { ...state.surveyDraft };
      }
      state.surveyDraft = { ...state.surveyDraft };
    },
    setSurveys(state, payload) {
      console.log("setSurvey payload = ", payload);
      state.surveys = [];
      if (payload.response.data !== "null") {
        const { data, total, current_page, per_page } = JSON.parse(
          payload.response.data
        );

        state.pagination = {
          perPage: per_page,
          currentPage: current_page,
          perPageOptions: [10, 25, 50, 100],
          total
        };
        // excute new surveys data
        if (payload.type === "new") {
          // Don't iterate in reverse order
          for (let i = 0; i < data.length; i++) {
            const currentSurvey = data[i];
            const eventsLength = currentSurvey.events
              ? currentSurvey.events.length
              : 0;
            for (let j = eventsLength - 1; j >= 0; j--) {
              const newSurvey = mapSurveyEventsData(currentSurvey, j);

              newSurvey.status = "pending";

              state.surveys.push(newSurvey);
            }
          }
        }

        // excute old surveys data
        if (payload.type === "old") {
          // Don't iterate in reverse order
          for (let i = 0; i < data.length; i++) {
            const currentSurvey = data[i];
            const eventsLength = currentSurvey.events
              ? currentSurvey.events.length
              : 0;
            for (let j = eventsLength - 1; j >= 0; j--) {
              const survey = mapSurveyEventsData(currentSurvey, j);

              survey.mission_csv = currentSurvey.events[j].mission_csv
                ? MAP_SMS_URL + currentSurvey.events[j].mission_csv
                : "";
              survey.flightlogs = currentSurvey.events[j].flightlogs
                ? currentSurvey.events[j].flightlogs
                : [];
              survey.mission_generate =
                currentSurvey.events[j].mission_generate;

              if (currentSurvey.events[j].weather) {
                survey.weather_avail = true;
                survey.weather_condition = currentSurvey.events[j].weather
                  .conditions
                  ? currentSurvey.events[j].weather.conditions
                  : "";
                survey.weather_temp = currentSurvey.events[j].weather.temp
                  ? currentSurvey.events[j].weather.temp
                  : 0.0;
                survey.weather_feelslike = currentSurvey.events[j].weather
                  .feelslike
                  ? currentSurvey.events[j].weather.feelslike
                  : 0.0;
                survey.weather_precipprob = currentSurvey.events[j].weather
                  .precipprob
                  ? currentSurvey.events[j].weather.precipprob
                  : 0.0;
                survey.weather_visibility = currentSurvey.events[j].weather
                  .visibility
                  ? currentSurvey.events[j].weather.visibility
                  : 0.0;
                survey.weather_cloudcover = currentSurvey.events[j].weather
                  .cloudcover
                  ? currentSurvey.events[j].weather.cloudcover
                  : 0;
                survey.weather_windspeed = currentSurvey.events[j].weather
                  .windspeed
                  ? currentSurvey.events[j].weather.windspeed
                  : 0.0;
                survey.weather_humidity = currentSurvey.events[j].weather
                  .humidity
                  ? currentSurvey.events[j].weather.humidity
                  : 0.0;
                survey.weather_description = currentSurvey.events[j].weather
                  .description
                  ? currentSurvey.events[j].weather.description
                  : "";
              } else {
                survey.weather_avail = false;
              }

              if (currentSurvey.events[j].aborted) {
                survey.status = i18n.t("aborted");
              } else if (currentSurvey.events[j].completed) {
                survey.status = i18n.t("checklist completed");
              } else {
                survey.status = i18n.t("checklist in progress");
              }

              survey.player_url = currentSurvey.events[j].player_url;
              state.surveys.push(survey);
              // if (survey.end > tday) { // TODO: check Backend logic, dose oldServey have newServey data
              //   state.newSurveys.push(survey);
              // }
            }
          }
        }
      }
    },
    setAirportDailySurveys(state, payload) {
      state.airportDailySurveys = JSON.parse(payload.response.data);
      EventBus.$emit("setAirportDailySurveys");
    },
    setSurveyGeoData(state, payload) {
      //https://docs.mapbox.com/mapbox-gl-js/example/add-image/

      state.oldSurveyGeoData = {
        type: "FeatureCollection",
        name: "old_survey_geodata",
        features: JSON.parse(payload.response.data.old_survey_geodatas)
      };

      state.newSurveyGeoData = {
        type: "FeatureCollection",
        name: "new_survey_geodata",
        features: JSON.parse(payload.response.data.new_survey_geodatas)
      };

      EventBus.$emit("setSurveyGeoData");
    },
    setIsclone(state, payload) {
      state.isclone = payload;
    },
    setSurveyDraft(state, payload) {
      if (payload.response.data === "null") {
        return;
      }
      const survey = JSON.parse(payload.response.data);
      let surveyDraft = formatSurveyDateForRender(survey);
      state.surveyDraft = surveyDraft;
      state.newSurvey = false;
    },
    setSurveyDraftFromClone(state, payload) {
      console.log(payload);
      let surveyDraft = formatSurveyDateForRender(payload);
      state.surveyDraft = surveyDraft;
      state.newSurvey = true;
    },
    saveSurveyDraftStepOne(state, payload) {
      if (state.newSurvey && payload.response.data.acknowledged) {
        state.newSurvey = false;
      }
    },
    saveSurveyDraftStepTwo(state, payload) {
      state.address = payload.address;
    },
    submitSurveyDraft(state, payload) {
      if (payload.response.data.submitted) {
        state.newSurvey = true;
        state.isclone = false;
        state.surveyDraft = getDefaultSurveyDraft();
      }
    },
    setCoordinates(state, payload) {
      state.surveyDraft.longitude = payload.coords.lng;
      state.surveyDraft.latitude = payload.coords.lat;
    },
    setMapboxCoordinates(state, payload) {
      const feature =
        (payload.response.data.features && payload.response.data.features[0]) ||
        {};
      state.surveyDraft.longitude = feature.center[0];
      state.surveyDraft.latitude = feature.center[1];
    },
    setAirport(state, payload) {
      if (payload.response.data) {
        state.surveyDraft.airport = JSON.parse(payload.response.data);
      }
    },
    setControlled(state, payload) {
      if (payload.response.data) {
        const { controlled, air_status } = payload.response.data;
        state.surveyDraft.controlled = controlled;
        state.surveyDraft.air_status = air_status;
        state.surveyDraft = { ...state.surveyDraft };
        EventBus.$emit("setControlled", controlled, air_status);
      }
    },
    saveMapImageData(state, payload) {
      state.surveyDraft.mapImageData = payload;
    },
    saveEvents(state, payload) {
      state.surveyDraft.events = [];

      var i;
      for (i = 0; i < payload.length; i++) {
        state.surveyDraft.events.push({
          title: payload[i].title,
          start: payload[i].start.toJSON(),
          end: payload[i].end.toJSON(),
          startLocal: moment(payload[i].start_loc).format("LLL"),
          endLocal: moment(payload[i].end_loc).format("LLL")
        });
      }
    },
    saveFlightLogs(state, payload) {
      const event = state.surveys.find(function(element) {
        return (
          element.pdf === payload.flightlogs.event.pdf &&
          element.start === payload.flightlogs.event.start &&
          element.end === payload.flightlogs.event.end
        );
      });
      event.flightlogs = [];
      payload.flightlogs.flightlogs.forEach(flight => {
        event.flightlogs.push({
          start_time: {
            HH: flight.start_time.HH,
            mm: flight.start_time.mm
          },
          end_time: {
            HH: flight.end_time.HH,
            mm: flight.end_time.mm
          }
        });
      });
    },
    setSMS(state, payload) {
      console.log("setSMS payload = ", payload);
      if (!payload.response.data.error) {
        state.sms = JSON.parse(payload.response.data);
        var count = 0;
        state.sms.forEach(sms => {
          sms.datetime = new Date(sms.timestamp.$date).toLocaleString("en-US");
          if (!sms.acknowledged) {
            count++;
          }
        });
        state.surveyNotificationCount = count;
      }
      EventBus.$emit("setSMS");
    },
    ackSMS(state, payload) {
      console.log("ackSMS payload = ", payload);
      if (!payload.response.data.error) {
        state.sms = state.sms.map(item => {
          if (item._id.$oid === payload.id) {
            item.acknowledged = true;
          }
          return item;
        });
        state.surveyNotificationCount -= 1;
      }
    },
    setLiveStreaming(state, payload) {
      console.log("setLiveStreaming = ", payload);
      if (!payload.response.data.error) {
        var survey = state.surveys.find(
          s =>
            s.pilotlicense === payload.payload.license &&
            s.start === payload.payload.start
        );
        survey.player_url = payload.response.data.player_url;
      }
    },
    setPagination(state, payload) {
      state.pagination = payload || getDefaultPagination();
    },
    setSurvetType(state, type) {
      state.surveyDraft.surveyType = type;
      const flightSchool = store.state.auth.flight_schools;
      if (
        type === SURVEY_TYPE.REVIEWER &&
        flightSchool &&
        flightSchool.length === 1
      ) {
        state.surveyDraft.flightSchool = flightSchool[0];
        if (state.isclone) {
          state.surveyDraft.reviewcustomer = "";
          state.surveyDraft.clientName = "";
          state.surveyDraft.clientEmail = "";
        }
      } else if (type !== SURVEY_TYPE.REVIEWER) {
        state.surveyDraft.reviewcustomer = "";
        state.surveyDraft.clientName = "";
        state.surveyDraft.clientEmail = "";
        state.surveyDraft.flightSchool = "";
      }
      state.surveyDraft = { ...state.surveyDraft };
    }
  },
  getters: {
    getField
  }
};
